import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _461d1781 = function _461d1781() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _9434a8f6 = function _9434a8f6() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _de3e659a = function _de3e659a() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _9adf6546 = function _9adf6546() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _64566f36 = function _64566f36() {
  return interopDefault(import('../pages/_market/_language/cart.vue'
  /* webpackChunkName: "pages/_market/_language/cart" */
  ));
};

var _dd35e3ee = function _dd35e3ee() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _7c37f074 = function _7c37f074() {
  return interopDefault(import('../pages/_market/_language/login.vue'
  /* webpackChunkName: "pages/_market/_language/login" */
  ));
};

var _01ab47af = function _01ab47af() {
  return interopDefault(import('../pages/_market/_language/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password" */
  ));
};

var _02387dde = function _02387dde() {
  return interopDefault(import('../pages/_market/_language/reset-password.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password" */
  ));
};

var _57200b1d = function _57200b1d() {
  return interopDefault(import('../pages/_market/_language/signup.vue'
  /* webpackChunkName: "pages/_market/_language/signup" */
  ));
};

var _416e7d83 = function _416e7d83() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _82a8b010 = function _82a8b010() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _08c08613 = function _08c08613() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _607c8d92 = function _607c8d92() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _b73294ba = function _b73294ba() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _5f7cf518 = function _5f7cf518() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _763639c1 = function _763639c1() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _460708ad = function _460708ad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _201b025a = function _201b025a() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _47177e62 = function _47177e62() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _2935c3d9 = function _2935c3d9() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _4825e614 = function _4825e614() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _479939f6 = function _479939f6() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _2758e55c = function _2758e55c() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
  ));
};

var _8c9316b8 = function _8c9316b8() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _54d7b5c0 = function _54d7b5c0() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _97e56824 = function _97e56824() {
  return interopDefault(import('../pages/_market/_language/t/shipping.vue'
  /* webpackChunkName: "pages/_market/_language/t/shipping" */
  ));
};

var _49dca458 = function _49dca458() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _758eee57 = function _758eee57() {
  return interopDefault(import('../pages/_market/_language/user/gift-card-download.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-card-download" */
  ));
};

var _d27f83d6 = function _d27f83d6() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _27178bf7 = function _27178bf7() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _57a145ac = function _57a145ac() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _1a07dc2d = function _1a07dc2d() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _6d42a506 = function _6d42a506() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _7089b04c = function _7089b04c() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _49b2f310 = function _49b2f310() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _59ca8d94 = function _59ca8d94() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _5dcc42dc = function _5dcc42dc() {
  return interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
  ));
};

var _630a90af = function _630a90af() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _adc0c504 = function _adc0c504() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _388be7aa = function _388be7aa() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _94beb04a = function _94beb04a() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _72e7c81d = function _72e7c81d() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _15d8a612 = function _15d8a612() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _5d241cb2 = function _5d241cb2() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
  ));
};

var _2db9260d = function _2db9260d() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
  ));
};

var _83bf947a = function _83bf947a() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
  ));
};

var _6b51788c = function _6b51788c() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
  ));
};

var _5eeecdac = function _5eeecdac() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
  ));
};

var _27bf267c = function _27bf267c() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _4cb676e2 = function _4cb676e2() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _07c0ed6e = function _07c0ed6e() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _3910e278 = function _3910e278() {
  return interopDefault(import('../pages/_market/_language/m/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/m/_alias" */
  ));
};

var _5025d295 = function _5025d295() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _988c0fe6 = function _988c0fe6() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _26d1fcbb = function _26d1fcbb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _461d1781,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _9434a8f6,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _de3e659a,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _9adf6546,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _64566f36,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _dd35e3ee,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _7c37f074,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _01ab47af,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _02387dde,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _57200b1d,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _416e7d83,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _82a8b010,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _08c08613,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _607c8d92,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _b73294ba,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _5f7cf518,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _763639c1,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _460708ad,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _201b025a,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _47177e62,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/login",
      component: _2935c3d9,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _4825e614,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _479939f6,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-canceled",
      component: _2758e55c,
      name: "market-language-t-payment-paypal-canceled"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _8c9316b8,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _54d7b5c0,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/shipping",
      component: _97e56824,
      name: "market-language-t-shipping"
    }, {
      path: "/:market/:language/t/signup",
      component: _49dca458,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-card-download",
      component: _758eee57,
      name: "market-language-user-gift-card-download"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _d27f83d6,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _27178bf7,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _57a145ac,
      children: [{
        path: "",
        component: _1a07dc2d,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _6d42a506,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _7089b04c,
        name: "market-language-user-profile-alerts"
      }, {
        path: "password",
        component: _49b2f310,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _59ca8d94,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/help/merchant/confirm",
      component: _5dcc42dc,
      name: "market-language-help-merchant-confirm"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _630a90af,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _adc0c504,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _388be7aa,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _94beb04a,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _72e7c81d,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _15d8a612,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact",
      component: _5d241cb2,
      name: "market-language-help-merchant-order-reference-contact"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/messages",
      component: _2db9260d,
      name: "market-language-help-merchant-order-reference-messages"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/notation",
      component: _83bf947a,
      name: "market-language-help-merchant-order-reference-notation"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/product/:code?",
      component: _6b51788c,
      name: "market-language-help-merchant-order-reference-contact-product-code"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/:code?",
      component: _5eeecdac,
      name: "market-language-help-merchant-order-reference-contact-code"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _27bf267c,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _4cb676e2,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _07c0ed6e,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/m/:alias?",
      component: _3910e278,
      name: "market-language-m-alias"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _5025d295,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _988c0fe6,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _26d1fcbb,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}